import { createContext, useContext } from 'react';
import type { Context } from 'react';

import type {
	SpaceNavigationQuery$data,
	SpaceNavigationQuery$variables,
} from './__generated__/SpaceNavigationQuery.graphql.ts';

type QueryData = {
	data: SpaceNavigationQuery$data;
	variables: SpaceNavigationQuery$variables;
};

export const SpaceNavigationQueryContext: Context<QueryData | undefined> = createContext<
	QueryData | undefined
>(undefined);

export const useSpaceNavigationQueryData = (): QueryData | undefined =>
	useContext(SpaceNavigationQueryContext);
